import { Button, Tooltip } from 'shared-ui';

import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { DeleteMultiOwnersProps } from './DeleteMultiOwners.types';

export const DeleteMultiOwners = ({
  checkedOwners,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: DeleteMultiOwnersProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const canEditOwner = perms?.[Functionality.KARTY_POSIADACZE]?.edit;

  return (
    <>
      <Tooltip title={formatMessage({ id: AppMessages['common.noPermissions'] })} disableHoverListener={canEditOwner}>
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={<TrashIcon />}
          onClick={onModalOpen}
          disabled={!canEditOwner}
        >
          {formatMessage({ id: AppMessages['cards.multiAction.delete.button'] })}
        </Button>
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['owners.multiAction.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['owners.multiAction.delete.submitButton'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['owners.multiAction.delete.subtitle'] })} {checkedOwners.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['owners.multiAction.delete.text'] })}</ActionModal.Text>

        <ActionModal.Text>{formatMessage({ id: AppMessages['common.irreversibleAction'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
